module.exports = __webpack_public_path__ + "img/cim-logo.43bf72d9.svg";